"use client";
import Image from "@components/common/Image";
import Author from "@components/common/Author";
import { useStrapiContext } from "@providers/StrapiProvider";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StrapiService/getter";
import styles from "./Intro.module.scss";
import cx from "classnames";
import { get, map } from "lodash";
import helper from "@utils/helper";
import Badge from "@components/common/Badge";
const View = () => {
  const { pageData } = usePageContext();
  const { str } = useStrapiContext();
  const tagData = getter.tags(pageData);
  // const tags = map(tagData, helper.formatTag);
  const author = helper.formatAuthor(getter.author(pageData));
  // const createdAt = getter.createdAt(pageData);
  const publishedAt = getter.publishedAt(pageData);

  return (
    <div className={cx(styles.section)}>
      <div className="mb-[2rem]">
        <h1 className={cx(styles.title, "title")}>{getter.title(pageData)}</h1>
        <Author {...{ ...author, publishedAt }} />
        <p className={styles.description}>{getter.description(pageData)}</p>
      </div>
      {/* <div className="inner-image">
        <Image
          {...getter.image(get(pageData, "attributes.image"))}
          wrapperProps={{ className: styles.image }}
          scale="1.02"
          speed="-0.4"
        />
      </div> */}
    </div>
  );
};
export default View;
